import React from 'react'
import {Button} from "react-bootstrap";

import styles from "./CTAButton.module.css";

const CTAButton = ({ className, label, onClick, size = 'normal', variant = 'primary', showArrow = true }) => (
  <Button className={`${styles.button} ${styles[size]} ${styles[variant]} ${className}`} onClick={onClick}>
    {label} {showArrow && <span className={styles.arrow}>&rarr;</span>}
  </Button>
)

export default CTAButton;